import React from 'react'

import DefaultNavbar from 'examples/Navbars/DefaultNavbar'
import MDBox from 'components/MDBox'

export default function navigazioneLanding(props) {
    return <DefaultNavbar backgroundColor="info" transparent relative light center routes={props.rotte} />
}
